import { render } from "./NosotrosHome.vue?vue&type=template&id=6e18bbca&scoped=true"
const script = {}

import "./NosotrosHome.vue?vue&type=style&index=0&id=6e18bbca&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e18bbca"]])

export default __exports__